<div class="filter-list" [class.filter-list--events-compact]="compact">
  <!-- Keyword -->
  <div class="filter-list__group">
    <h2 class="filter-list__group-header">University Name (optional)</h2>
    <div class="filter-list__group-content">
      <input id="universityName" type="text" class="landing-page__field landing-page__query-field"
             [(ngModel)]="universityFinderFilter.name" (input)="onNameChange()"
             aria-label="University Name" autocomplete="off" autocorrect="off"
             [attr.aria-invalid]="nameTooShort ? true : null"
             [attr.aria-describedby]="nameTooShort ? 'universityNameError' : null">
      <div *ngIf="nameTooShort" id="universityNameError" class="university-filter__validation-message" role="alert">
        Please enter at least three characters to search by university name.
      </div>
    </div>
  </div>
</div>

<div class="filter-list" [class.filter-list--events-compact]="compact">
  <!-- Degrees (AND logic) -->
  <div class="filter-list__group">
    <h2 class="filter-list__group-header">Degrees</h2>
    <div class="filter-list__group-buttonbar">
      <span class="filter-list__group-button" (click)="onSelectAll('degrees', degreeOptions)">Select All</span> |
      <span class="filter-list__group-button" (click)="onClearAll('degrees')">Clear All</span>
    </div>
    <div class="filter-list__group-content">
      <div class="filter" *ngFor="let option of degreeOptions">
        <mat-checkbox [checked]="isFacetSelected('degrees', option.value)"
                      (change)="onToggleFacet('degrees', option.value, $event.checked)"
                      [attr.aria-label]="option.label" class="filter__checkbox">
          <div class="filter__header"><span class="filter__label">{{ option.label }}</span></div>
        </mat-checkbox>
      </div>
    </div>
  </div>

  <!-- Majors (AND logic) -->
  <div class="filter-list__group">
    <h2 class="filter-list__group-header">Majors</h2>
    <div class="filter-list__group-buttonbar">
      <span class="filter-list__group-button" (click)="onSelectAll('majors', majorOptions)">Select All</span> |
      <span class="filter-list__group-button" (click)="onClearAll('majors')">Clear All</span>
    </div>
    <div class="filter-list__group-content">
      <div class="filter" *ngFor="let option of majorOptions">
        <mat-checkbox [checked]="isFacetSelected('majors', option.value)"
                      (change)="onToggleFacet('majors', option.value, $event.checked)"
                      [attr.aria-label]="option.label" class="filter__checkbox">
          <div class="filter__header"><span class="filter__label">{{ option.label }}</span></div>
        </mat-checkbox>
      </div>
    </div>
  </div>

  <!-- Accreditation (AND logic) -->
  <div class="filter-list__group">
    <h2 class="filter-list__group-header">Accreditation</h2>
    <div class="filter-list__group-buttonbar">
      <span class="filter-list__group-button" (click)="onSelectAll('accreditation', accreditationOptions)">Select All</span> |
      <span class="filter-list__group-button" (click)="onClearAll('accreditation')">Clear All</span>
    </div>
    <div class="filter-list__group-content">
      <div class="filter" *ngFor="let option of accreditationOptions">
        <mat-checkbox [checked]="isFacetSelected('accreditation', option.value)"
                      (change)="onToggleFacet('accreditation', option.value, $event.checked)"
                      [attr.aria-label]="option.label" class="filter__checkbox">
          <div class="filter__header"><span class="filter__label">{{ option.label }}</span></div>
        </mat-checkbox>
      </div>
    </div>
  </div>

  <!-- Additional (AND logic) -->
  <div class="filter-list__group">
    <h2 class="filter-list__group-header">Additional</h2>
    <div class="filter-list__group-buttonbar">
      <span class="filter-list__group-button" (click)="onSelectAll('options', optionOptions)">Select All</span> |
      <span class="filter-list__group-button" (click)="onClearAll('options')">Clear All</span>
    </div>
    <div class="filter-list__group-content">
      <div class="filter" *ngFor="let option of optionOptions">
        <mat-checkbox [checked]="isFacetSelected('options', option.value)"
                      (change)="onToggleFacet('options', option.value, $event.checked)"
                      [attr.aria-label]="option.label" class="filter__checkbox">
          <div class="filter__header"><span class="filter__label">{{ option.label }}</span></div>
        </mat-checkbox>
      </div>
    </div>
  </div>

</div>
